import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  Output,
  SimpleChanges,
  EventEmitter,
  TemplateRef,
  ViewChild,
  NgZone,
  Inject,
  forwardRef
} from '@angular/core';

import { isEqual, isNil, isEmpty, set } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil, mergeMap, shareReplay } from 'rxjs/operators';
import { BaseComponent } from './components/base.component';
import { SharedModule } from './shared.module';import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DatexFormControl, validateControlOnChange, validateFormOnControlChange } from './models/datex-form-control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { FieldsetModel } from './models/fieldset';
import { ToolModel } from './models/tool';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles,
  ValueControlModel
} from './models/control';
import { datCodeValidator } from './components/code-validator.directive';import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { PurchaseOrders_ShellService } from './PurchaseOrders.shell.service';
import { PurchaseOrders_OperationService } from './PurchaseOrders.operation.service';
import { PurchaseOrders_DatasourceService } from './PurchaseOrders.datasource.index';
import { PurchaseOrders_FlowService } from './PurchaseOrders.flow.index';
import { PurchaseOrders_FrontendFlowService } from './PurchaseOrders.frontend.flow.service';
import { PurchaseOrders_ReportService } from './PurchaseOrders.report.index';
import { PurchaseOrders_LocalizationService } from './PurchaseOrders.localization.service';
import { PurchaseOrders_home_ComponentContextService } from './PurchaseOrders.home.component.context.service';
import { Language } from './localization.service';
import { JobStatus, EAssignmentMode } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { $frontendTypes} from './PurchaseOrders.frontend.types'
import { $frontendTypes as $types} from './PurchaseOrders.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

@Component({
  imports: [
    SharedModule,
  ],
  selector: 'PurchaseOrders-home',
  templateUrl: './PurchaseOrders.home.component.html'
})
export class PurchaseOrders_homeComponent extends BaseComponent implements OnInit, OnDestroy {


  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  //#endregion

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  formGroup = new FormGroup({
  });

  get valid(): boolean {
    return this.formGroup.valid;
  }
  
  toolbar = {
  };

  fields = {
  };

  fieldsets = {
};


  $formGroupFieldValidationObservables = {
  }
  

  constructor(
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: PurchaseOrders_ShellService,
private $datasources: PurchaseOrders_DatasourceService,
private $flows: PurchaseOrders_FlowService,
private $frontendFlows: PurchaseOrders_FrontendFlowService,
private $reports: PurchaseOrders_ReportService,
private $localization: PurchaseOrders_LocalizationService,
private $operations: PurchaseOrders_OperationService,
private $context: PurchaseOrders_home_ComponentContextService,
) { 
    super();
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  initialized = false;

  async $init() {
    this.title = 'PurchaseOrders';
  
    const $form = this;
    const $utils = this.$utils;



    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
  }

  close() {
    this.$finish.emit();
  }

  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }
 
}
